<template>
    <div class="set-up-account">
        <h3>{{ $TL.accountSetting }}</h3>
        <div class="panel d-flex">
            <div class="avatar-slot">
                <p>{{ $TL.avatar }}：</p>
                <div class="avatar">
                    <div
                        class="avatar-box"
                        :style="`background-image:url(${avatar});`"
                    ></div>
                </div>
                <v-file-input
                    :rules="rules"
                    class="upload-file"
                    accept="image/png, image/jpeg, image/bmp"
                    :label="$TL.uploadAvatar"
                    v-model="image"
                    @change="preview_avatar"
                />
            </div>
            <div class="account-info-slot">
                <v-form v-model="valid" ref="form">
                    <label>
                        <span>{{ $TL.nickName }}：</span>
                        <v-text-field
                            v-model="nickname"
                            :counter="30"
                            :rules="nicknameRules"
                        />
                    </label>
                    <label>
                        <span>{{ $TL.username }}：</span>
                        <v-text-field
                            class="username"
                            :value="userCenteredInfo.username"
                            readonly
                        />
                    </label>
                    <label class="old-password-label">
                        <span>{{ $TL.changePassword }}：</span>
                        <v-text-field
                            v-model="oldPassword"
                            :rules="passwordRules"
                            :counter="20"
                            :label="$TL.enterOldPassword"
                            :error-messages="errorPassword"
                            required
                        />
                    </label>
                    <label class="new-password-label">
                        <v-text-field
                            v-model="password"
                            :rules="passwordRules"
                            :counter="20"
                            :label="$TL.enterNewPassword"
                            required
                        />
                    </label>
                    <div class="operate-btm d-flex justify-content-end">
                        <v-btn class="cancel-btn def" @click="cancel">{{
                            $TL.cancel
                        }}</v-btn>
                        <v-btn class="save-btn def gradient-bg" @click="save">{{
                            $TL.save
                        }}</v-btn>
                    </div>
                </v-form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { reviseUserProfile, uploadAvatar } from "@/api/interface.js";
export default {
    name: "set-up-account",

    data() {
        return {
            valid: false,
            rules: [
                value => !value || value.size < 2000000 || this.$TL.avatarOver
            ],
            passwordRules: [
                v => !v || v.length >= 4 || this.$TL.passwordCannotLess4digits,
                v =>
                    !v || v.length <= 20 || this.$TL.passwordCannotExceed20Char,
                v =>
                    !v ||
                    this.oldPassword !== this.password ||
                    this.$TL.cantReuseOldPass
            ],
            nicknameRules: [
                v => !v || v.length <= 30 || this.$TL.lengthCannotExceed30Char
            ],
            image: null,
            avatar: "",
            nickname: "",
            oldPassword: "",
            password: "",
            errorPassword: "",
            priorityOldPass: this.$TL.enterOldPass
        };
    },
    computed: {
        ...mapState("userCentered", ["userCenteredInfo"])
    },
    created() {
        this.avatar = this.userCenteredInfo.avatar || this.$P.defaultAvatar;
        this.nickname = this.userCenteredInfo.name;
    },
    mounted() {},
    methods: {
        ...mapMutations("userCentered", ["updateUserCenteredInfo"]),
        ...mapMutations("triggerEvtents", ["updateSnackbar"]),
        cancel() {
            this.nickname = this.password = "";
            this.$P.$emit("closeModal");
        },
        async save() {
            //  只填了新密码没填写旧密码
            if (this.oldPassword.trim() === "" && this.password.trim() !== "") {
                this.errorPassword = this.priorityOldPass;
                return;
            } else {
                this.errorPassword = "";
            }

            if (!this.$refs.form.validate()) return;
            let option = {
                name: this.nickname,
                username: this.userCenteredInfo.username,
                old_password: this.oldPassword,
                password: this.password
            };

            try {
                //  提交修改的用户名，密码
                await reviseUserProfile(option);
                this.updateUserCenteredInfo({
                    name: this.nickname
                });
                this.$P.$emit("closeModal");
                this.updateSnackbar(this.$TL.InforModifiedSuccess);
            } catch (e) {
                if (e?.response.status === 400) {
                    this.errorPassword = e.response.data.message ?? "";
                }
            }

            //  提交修改的头像
            this.upload_avatar();
        },
        preview_avatar() {
            this.avatar = URL.createObjectURL(this.image);
        },
        async upload_avatar() {
            if (!this.image) return;
            let formData = new FormData();
            formData.append("file", this.image);
            try {
                let { data } = await uploadAvatar(
                    this.userCenteredInfo.id,
                    formData
                );
                //  更新store 中的头像
                this.updateUserCenteredInfo({
                    avatar: data.avatar
                });
                this.updateSnackbar(this.$TL.InforModifiedSuccess);
            } catch (e) {
                if (e?.response.status === 500) {
                    this.updateSnackbar(this.$TL.avatarUploadUailed);
                }
            }
        }
    }
};
</script>

<style lang="scss">
.setUpAccount {
    .v-dialog {
        width: 582px;
    }
}

.set-up-account {
    padding: 0 8px 16px 8px;

    h3 {
        font-weight: normal;
    }

    .panel {
        margin-top: 20px;
        padding: 0 26px;
        .v-label {
            text-overflow: inherit;
            overflow: inherit;
            font-size: 14px;
            color: #999;
        }

        .v-input__slot {
            &::before,
            &::after {
                display: none;
            }
        }
    }

    .avatar-slot {
        p {
            font-size: 14px;
            margin: 0;
        }

        .avatar {
            width: 144px;
            height: 144px;
            // border: 1px dashed #dfe1e5;
            margin-top: 8px;
            @include flex(center, center);

            .avatar-box {
                width: 90%;
                height: 90%;
                overflow: hidden;
                border-radius: 50%;
                position: relative;

                background: {
                    repeat: no-repeat;
                    size: cover;
                    position: center center;
                }

                img {
                    max-height: 100%;
                    width: auto;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50px);
                }
            }

            .v-text-field__details {
                display: flex;
                padding-top: 4px;
            }
        }

        .v-input__control {
            justify-content: center;
        }

        .v-file-input {
            .v-input__slot {
                padding: 6px 16px;
                margin-top: 16px;
                border: 1px solid #dfe1e5;
                font-size: 14px;
                border-radius: $border-radius;
                width: 78%;
                margin-left: 12%;
                cursor: pointer;

                background: {
                    image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciICB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgb3BhY2l0eT0iMC42NSI+PHBhdGggZD0iTTIgMTJINFYxN0gyMFYxMkgyMlYxN0MyMiAxOC4xMSAyMS4xMSAxOSAyMCAxOUg0QzIuOSAxOSAyIDE4LjExIDIgMTdWMTJNMTIgMkw2LjQ2IDcuNDZMNy44OCA4Ljg4TDExIDUuNzVWMTVIMTNWNS43NUwxNi4xMyA4Ljg4TDE3LjU1IDcuNDVMMTIgMloiIC8+PC9zdmc+);
                    repeat: no-repeat;
                    size: auto 60%;
                    position: 10% center;
                }
            }

            .v-input__icon,
            .v-input__append-inner,
            .v-input__prepend-outer,
            .v-file-input__text {
                display: none;
            }

            .v-text-field__slot {
                min-height: auto;
                justify-content: flex-end;
            }
        }

        .upload-file {
            .v-label.v-label--active {
                display: block;
                pointer-events: none;
            }

            .v-text-field__details {
                margin-top: 16px;
                text-align: center;
                * {
                    width: 100%;
                    text-align: center;
                }
            }
        }
    }

    .account-info-slot {
        width: 240px;
        margin-left: 96px;
        label {
            width: 100%;
            margin-bottom: 8px;
            span {
                display: inline-block;
                font-size: 14px;
            }

            .username {
                input {
                    color: #b9b9b9;
                }
            }

            .v-input__slot {
                height: 40px;
                border: 1px solid #dfe1e5;
                border-radius: $border-radius;
                margin-top: 8px;
                padding: 0 10px;

                @include flex(center);

                .v-label {
                    position: absolute !important;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }
            }

            .v-text-field__details {
                padding-top: 4px;
            }
        }

        .old-password-label {
            margin-bottom: 0;
        }
    }

    .operate-btm {
        margin-top: 16px;

        .cancel-btn {
            margin-right: 8px;
        }
    }
}
</style>
